import { Cell, Row } from "@tanstack/react-table";

import CellCheckbox from "./checkbox";
import CellDate from "./date";
import CellInput from "./input";
import CellSelect from "./select";

export default function CellControl<T>({
  options,
  row,
  cell,
}: {
  options?:
    | {
        type: "text" | "number" | "date" | "checkbox";
      }
    | {
        type: "select";
        options: {
          value: string | boolean;
          label: string;
        }[];
      };
  row: Row<T>;
  cell: Cell<T, unknown>;
}) {
  switch (options?.type) {
    case "text":
      return <CellInput row={row} cell={cell} />;
    case "number":
      return <CellInput row={row} cell={cell} />;
    case "date":
      return <CellDate row={row} cell={cell} />;
    case "select":
      return <CellSelect row={row} cell={cell} options={options.options} />;
    case "checkbox":
      return <CellCheckbox row={row} cell={cell} />;
    default:
      return <CellInput row={row} cell={cell} />;
  }
}
